export default "__VITE_ASSET__CcfGAvcx__"